module.exports = __webpack_public_path__ + "img/pr-4.4a5222a7.png";